export default "__VITE_ASSET__vUy3$N4u__"